module.exports = __webpack_public_path__ + "img/xp_background.42413b55.png";